export default __webpack_public_path__ + "static/ai-gen-footer-dark-e4a5421a9f97e8cb519cbfb5e6de2887a55064b15893a7fb3073146a1a61f2a9.png";